import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

if (typeof window !== "undefined") {
  const STALE_CHUNK_RELOAD_KEY = "hookstream:stale-chunk-reload";

  window.addEventListener("load", () => {
    sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
  }, { once: true });

  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();

    if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) === "1") {
      sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
      console.error("Chunk preload failed after a recovery reload.", event);
      return;
    }

    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, "1");
    window.location.reload();
  });
}

const rootEl = document.getElementById("root")!;

// SSR pre-renders HTML for crawlers (SEO). The client always does a fresh
// React render for full interactivity. This avoids hydration mismatches
// from auth state, portals (Toaster), canvas elements, etc.
createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
